import DateUtils from "@gap/utils/date-utils"
import { makeAutoObservable } from "mobx"

export class ObservableTime {
   private static instance: ObservableTime
   private epoch = Date.now()

   private constructor() {
      setInterval(() => {
         this.epoch = Date.now()
      }, 1000)
      makeAutoObservable(this)
   }

   get currentEpoch() {
      return this.epoch
   }

   static getInstance() {
      if (!ObservableTime.instance) {
         ObservableTime.instance = new ObservableTime()
      }

      return ObservableTime.instance
   }

   renderRelativeTime(time: Date) {
      return DateUtils.formatAsRelativeTime({ compareTime: time, baseTime: new Date(this.currentEpoch) })
   }
}
